<div class="titolo-dialog">
  <h2 mat-dialog-title style="font-size: 25px">Selezione Domande Inforamtiva Aziendale</h2>
</div>

<div mat-dialog-content class="dialog-center-cont">
  <div style="height: 10px"></div>
  <!--   <ng-scrollbar #scrollDialog> -->

  <!-- ---------------------------------------- D O M A N D E  ------------------------- -->
  <div class="cont-dd" appFormContainer [larghezza]="2">
    <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
      <div class="cont-titolo">
        <mat-label class="titolo">Domande Selezionate</mat-label>
        <div>
          <button
            mat-flat-button
            class="imp-esclud"
            color="accent"
            (click)="apriFiltroSelezionati('domande')"
            matBadgeColor="warn"
          >
            <mat-icon matSuffix>filter_list</mat-icon>
            Filtri
          </button>
        </div>
      </div>
      <ng-scrollbar #scrollSelezionate>
        <div
          scrollViewport
          dropListScroller
          cdkDropList
          #selListDomande="cdkDropList"
          [cdkDropListData]="arrayDomandeSel"
          [cdkDropListConnectedTo]="[dispListDomande]"
          class="list"
          (cdkDropListDropped)="dropDomande($event)"
        >
          <div class="nessun-elemento" *ngIf="!arrayDomandeSel?.length && !loadingDisponibili">
            <p>Nessuna domanda selezionata</p>
          </div>

          <div
            class="box"
            *ngFor="let sel of arrayDomandeSelFiltrati"
            cdkDrag
            [matTooltip]="sel.domanda"
            [cdkDragData]="sel"
          >
            <div class="box-sx">
              <button mat-icon-button title="Sposta" aria-label="Sposta">
                <mat-icon> drag_handle </mat-icon>
              </button>
              <mat-label class="truncate">{{ sel.domanda }}</mat-label>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
    <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
      <div class="cont-titolo">
        <mat-label class="titolo">Domande Disponibili</mat-label>
        <div>
          <button
            mat-flat-button
            class="imp-esclud"
            color="accent"
            (click)="apriFiltro('domande')"
            matBadgeColor="warn"
          >
            <mat-icon matSuffix>filter_list</mat-icon>
            Filtri
          </button>
        </div>
      </div>
      <ng-scrollbar #scrollDisponibili>
        <div
          cdkDropList
          scrollViewport
          dropListScroller
          #dispListDomande="cdkDropList"
          [cdkDropListData]="arrayDomande"
          [cdkDropListConnectedTo]="[selListDomande]"
          class="list"
          style="background-color: #f5f5f5"
          (cdkDropListDropped)="dropDomande($event)"
        >
          <div class="elemento-disp" *ngIf="loadingDisponibili">
            <mat-spinner style="height: 50px"></mat-spinner>
          </div>

          <div class="nessun-elemento" *ngIf="!arrayDomande?.length && !loadingDisponibili">
            <p>Nessuna Domanda Disponibile</p>
          </div>

          <div
            class="box"
            style="background-color: #f5f5f5"
            *ngFor="let disp of arrayDomande"
            cdkDrag
            [cdkDragData]="disp"
            [matTooltip]="disp.domanda"
          >
            <div class="box-sx">
              <button mat-icon-button title="Sposta" aria-label="Sposta">
                <mat-icon> drag_handle </mat-icon>
              </button>
              <mat-label class="truncate">{{ disp.domanda }}</mat-label>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </div>

  <!--     </ng-scrollbar> -->
  <div style="height: 10px"></div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-flat-button color="accent" (click)="completa()" class="accent-button">
      Chiudi
    </button>
  </div>
</div>
